module.exports = __webpack_public_path__ + "img/Whispers.91126367.png";